<template>
  <div class="Payment-view">
    <v-card flat v-if="isLoading">
      <v-card-text>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </v-card>
    <div v-else>
      <v-card flat>
        <ReportViewBar
          v-if="Payment"
          :title="`Payment List`"
          :start="start"
          :end="end"
        />

        <v-container fluid>
          <table class="center">
            <tbody class="report-container">
              <v-card-text>
                <v-data-table
                  dense
                  sort-by="date"
                  readonly
                  :headers="headers"
                  :itemsPerPage="Payment.length"
                  hide-default-footer
                  :items="Payment"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td class="text-left">
                        {{ item.date | moment("MM/DD/YYYY") }}
                      </td>
                      <td class="text-left text-capitalize" v-if="item.Customer">
                        {{ item.Customer.name }}
                      </td>
                      <td class="text-left text-capitalize" v-else>
                        Null
                      </td>
                      <td class="text-left">
                        {{ item.paymentMethod }}
                      </td>
                      <td class="text-right">
                        {{ item.total | currency }}
                      </td>
                    </tr>
                  </template>
                  <template
                    v-slot:body.append="{ headers }"
                    v-if="Payment.length > 0"
                  >
                    <tr
                      :style="{ 'background-color': $style.listTotal.filter }"
                    >
                      <td></td>
                      <td></td>
                      <td
                        :colspan="headers.length - 3"
                        class="text-right font-weight-bold"
                      >
                        Total
                      </td>
                      <td class="text-right font-weight-bold">
                        {{ total | currency }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </tbody>
          </table>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import ReportViewBar from "@/components/ReportViewBar";
// import CategoryService from "@/modules/Category/service";
import paymentService from "@/modules/Payment/service";
// import Hashids from "hashids";
// const hashids = new Hashids();

export default {
  data() {
    return {
      start: null,
      end: null,
      isLoading: true,
      Payment: [],
      headers: [
        {
          text: "DATE",
          align: "left",
          value: "name",
          sortable: true
        },
        {
          text: "CUSTOMER",
          align: "left",
          value: "payee",
          sortable: true
        },
        {
          text: "PAYMENT METHOD",
          align: "left",
          value: "note",
          sortable: true
        },
        {
          text: "AMOUNT",
          align: "right",
          value: "amount",
          sortable: true
        }
      ]
    };
  },
  computed: {
    total() {
      let total = 0;
      this.Payment.map(row => {
        total += row.total;
      });
      return total;
    }
  },
  async created() {
    this.start = this.$route.query.start;
    this.end = this.$route.query.end;
    await this.getAll();
  },
  components: { ReportViewBar },
  methods: {
    getAll() {
      let where = {
        start: this.start,
        end: this.end
      };

      return paymentService.getAll(where).then(response => {
        console.log("response category", response);
        this.$Progress.finish();
        this.Payment = response.data;
        this.isLoading = false;
      });
    }
  }
};
</script>

<style scoped>
@media print {
  container {
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }
  .no-print {
    display: none;
  }
  .detailBox {
    overflow: visible;
    height: 100%;
  }
  * {
    background: 0 0 !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
}
.paidImg {
  position: absolute;
  left: 40%;
  top: 10%;
}

.signature {
  margin-top: 100px;
}
.center {
  background-color: white;
  margin: auto;
  width: 100%;
}
/* @media print {
  .detailBox * {
    overflow: visible;
    height: 100%;
    page-break-before: always;
  }
}
.detailBox {
  overflow: auto;
  height: 600px;
} */
</style>
